<div class="tr layout-row layout-align-start-center">
     <!-- TODO: Restore mouse events when draft names become editable -->
     <!-- (mouseenter)="onMouseEnter()" -->
     <!-- (mouseleave)="onMouseLeave()"> -->

  <!-- Name (read-only) -->
  <!-- TODO: Restore inline editing when draft names become editable -->
  <div class="td small flex-25 layout-row layout-align-start-center">
    <span class="text-ellipsis">{{draft.name}}</span>
    
    <!-- TODO: Restore edit functionality when draft names become editable -->
    <!-- View mode -->
    <!-- <div *ngIf="!isEditing" class="layout-row layout-align-start-center flex">
      <a class="br-link-1 text-ellipsis" (click)="onOpenDraft($event)">{{draft.name}}</a>
      <bringoz-button  *ngIf="isHovered" type="tertiary" (click)="onStartEdit($event)">
        <bringoz-icon iconName="edit-outline" class-size="xxl"></bringoz-icon>
      </bringoz-button>
    </div> -->

    <!-- Edit mode -->
    <!-- <div *ngIf="isEditing" class="layout-row layout-align-start-center flex">
      <input class="form-control margin-0 flex"
             type="text"
             [(ngModel)]="editingName"
             (keydown.enter)="onSaveEdit($event)"
             (keydown.escape)="onCancelEdit($event)">
      <bringoz-button  *ngIf="isHovered" type="tertiary" (click)="onSaveEdit($event)">
        <bringoz-icon iconName="check" class-size="xxl"></bringoz-icon>
      </bringoz-button>
      <bringoz-button  type="tertiary" (click)="onCancelEdit($event)">
        <bringoz-icon iconName="close" class-size="xxl"></bringoz-icon>
      </bringoz-button>
    </div> -->
  </div>

  <!-- Routes -->
  <div class="td small flex">{{draft.routesNumber}}</div>

  <!-- Creation Date -->
  <div class="td small flex">{{draft | bringozDate: 'createdAt'}}</div>

  <!-- Last Modification Date -->
  <div class="td small flex">{{draft | bringozDate: 'updatedAt'}}</div>

  <!-- Delete -->
  <div class="td small flex layout-row layout-align-end-center">
    <div ngbTooltip="{{'Delete' | translate}}" container="body">
      <bringoz-button type="tertiary" (click)="onDelete($event)">
        <bringoz-icon iconName="trash" class-size="xxl"></bringoz-icon>
      </bringoz-button>
    </div>
  </div>
</div>
